export const isAudioWorkletNode = (audioNode) => {
    return 'port' in audioNode;
};
//# sourceMappingURL=/build/es2018/guards/audio-worklet-node.js.map